import React, { useEffect, useRef } from "react";


export default function BarcodeInput({ onDetect, placeholder = "Scanner / saisir code-barres" }) {
    const ref = useRef(null);
    useEffect(() => { ref.current?.focus(); }, []);


    return (
        <input
            ref={ref}
            className="form-control form-control-lg"
            placeholder={placeholder}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    const code = e.currentTarget.value.trim();
                    if (code) onDetect(code);
                    e.currentTarget.value = "";
                }
            }}
        />
    );
}